import styled from 'styled-components';
import { PhoneInput } from 'react-international-phone';
import { LayoutColors } from '@src/core/theme';
import { BodySmallMedium } from '@src/fonts/typography/Typography';

export const StyledInput = styled(PhoneInput)<InputProps>`
  border: 1px solid rgb(148, 148, 148);
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;

  ${(props) => (props.error ? `border-color: ${LayoutColors.errorDark}` : '')};

  .react-international-phone-country-selector-button {
    border: 0;
    padding: 0 8px;
  }

  .react-international-phone-flag-emoji {
    margin-right: 8px;
  }

  .react-international-phone-country-selector {
    border: 0;
  }

  .react-international-phone-input {
    border: 0;
    color: #595959;
    flex-grow: 1;
  }

  .react-international-phone-country-selector-dropdown {
    width: max-content;
    padding: 4px;

    li {
      span {
        ${BodySmallMedium};
        color: ${LayoutColors.blackMain};
      }
    }
  }

  .react-international-phone-country-selector-dropdown__list-item-country-name {
    display: none;
  }
`;

export const WrapperInputMask = styled.div`
  width: 100%;
`;

export const Label = styled.label`
  ${BodySmallMedium};
  display: block;
  margin-bottom: 8px;
  color: ${LayoutColors.blackMain};
`;

interface HelperTextProps {
  error: boolean;
}

export const HelperText = styled.div<HelperTextProps>`
  display: inline-block;
  font-size: 12px;
  letter-spacing: 0em;
  text-align: left;
  color: ${(props) => (props.error ? LayoutColors.errorDark : '#4d4d4d')};
`;

interface InputProps {
  error: boolean;
}
